export default __webpack_public_path__ + "static/media/Quality.08437ba1.png";